/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Logger } from "@html-core";
import { HorizonIndexedDBService } from "../../../../core/services/storage/horizon-indexed-db.service";
import { HTML5FileSystemDirectoryHandler } from "../../../../html5-client/desktop/cdr/html5-file-system-directory-handler";
import { HorizonFileSystem } from "./horizon-file-system";
import { CDRInfoInIndexedDB } from "./cdr-interface";

const INDEXED_DB_VERSION = 1;
export class Html5FileSystem extends HorizonFileSystem {
   private _logger;
   constructor() {
      super();
      this._logger = new Logger(Logger.CDR);
   }

   public isRestorable = (info, callback) => {
      //Todo
      return new Promise((resolve, reject) => {
         resolve(info.entry);
      });
   };

   public chooseEntry = () => {
      return new Promise((resolve, reject) => {
         window
            //@ts-ignore
            .showDirectoryPicker({ mode: "readwrite" })
            .then(async (directoryHandler) => {
               this._logger.info("user allow to edit the selected file in cdr file picker");
               const directoryEntry = new HTML5FileSystemDirectoryHandler(directoryHandler);
               const permission = await directoryHandler.requestPermission({ mode: "readwrite" });
               if (permission === "granted") {
                  this._logger.debug("User accept the read-write permission");
                  resolve(directoryEntry);
               } else {
                  this._logger.debug("User reject the Read-write permission");
                  reject();
               }
            })
            .catch((e) => {
               this._logger.info("user refuse to edit the selected file in cdr file picker");
               reject();
            });
      });
   };

   public retainEntry = (entry): string => {
      return entry.folderId;
   };

   public getWritableEntry = (entry) => {
      return new Promise((resolve, reject) => {
         resolve(entry);
      });
   };
   public getDisplayPath = (rootEntry, callback) => {
      if (rootEntry) {
         const fullPath = "/" + rootEntry.name;
         callback(fullPath);
      }
   };

   public getDirectoryEntryFromStorage = (name) => {
      return new Promise((resolve, reject) => {
         HorizonIndexedDBService.get("HorizonFolderSharing", "folder-entries", name)
            .then(async (res: any) => {
               const info = [];
               if (res && res.folderEntry) {
                  this._logger.info("Get " + res.folderEntry.length + " folder entries from database");
                  for (let i = 0; i < res.folderEntry.length; i++) {
                     const directoryEntry = new HTML5FileSystemDirectoryHandler(res.folderEntry[i]);
                     info.push({
                        id: directoryEntry.folderId,
                        entry: directoryEntry,
                        path: "/" + res.folderEntry[i].name
                     });
                     this._logger.debug("Push entry " + directoryEntry.folderId + " in the array.");
                  }
                  resolve(info);
               } else {
                  resolve([]);
               }
            })
            .catch((e) => {
               resolve([]);
               this._logger.debug(e);
            });
      });
   };

   public saveDirectoryEntryInStorage = (folderId, folderEntry) => {
      return new Promise((resolve, reject) => {
         const data: CDRInfoInIndexedDB = {
            folderId: folderId,
            folderEntry: folderEntry,
            version: INDEXED_DB_VERSION
         };
         HorizonIndexedDBService.set("HorizonFolderSharing", "folder-entries", folderId, data)
            .then((res) => {
               resolve(res);
            })
            .catch(() => {
               resolve(false);
            });
      });
   };
}
